import { Component, OnInit, Inject, forwardRef, ChangeDetectorRef } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'design-options',
  templateUrl: './design-options.component.html',
  styleUrls: ['./design-options.component.css']
})
export class DesignOptionsComponent implements OnInit {

  selectFont = '';
  text = "";
  showInnerColorOptions = true;
  artworkColorOptionsSelection = 'outerBorder';

  showFontOptions = false;
  // artworkColorOptionsSelection = 'innerBorder';
  // artworkColorOptionsSelection = 'bg';


  constructor(
    @Inject(forwardRef(() => AppComponent)) public parent : AppComponent,
    private cd : ChangeDetectorRef
    ) {
      
     }

  selectedDesignOption : any = '';

  openResizeButtons : boolean = false;
  ngOnInit() {
    this.openResizeButtons = false;
    if(this.parent.selectedArea && this.parent.selectedArea.selectedStyle && this.parent.selectedArea.selectedStyle.text && this.parent.selectedArea.selectedStyle.text.text){
      this.text = this.parent.selectedArea.selectedStyle.text.text;
    }

    this.artworkColorOptionsSelection = 'outerBorder';
    // console.log("this.parent.selectedArea : ", this.parent.selectedArea)
    // console.log('this.parent.selectedArea.selectedStyle.text.text : ', this.parent.selectedArea.selectedStyle.text.text)
    if(this.parent && this.parent.selectedArea && this.parent.selectedArea.selectedStyle && this.parent.selectedArea.selectedStyle.text && this.parent.selectedArea.selectedStyle.text.text){
      this.text = this.parent.selectedArea.selectedStyle.text.text;
      this.selectFont = this.parent.selectedArea.selectedStyle.text.font;
      this.cd.detectChanges();
    }
  }

  goBack(){
    if(this.selectedDesignOption){
      this.selectedDesignOption = '';
    }else{
      this.selectedDesignOption = '';
      this.parent.removeActivePath(this.parent.selectedArea.selector);
      this.parent.selectedArea.active = false;
      this.parent.selectedArea = '';
    }
  }

  selectFontChange(selectFont){
    console.log('selectFont : ', selectFont);
    // this.parent.selectedArea.selectedStyle.text.text;
  }

  selectInnerArtWorkColor(color){
    // this.parent.config.customisationDefaults.inner[0].innerDesignSelectedColor = color;
    this.parent.config.customisationDefaults.inner[0].innerColor = color;
    this.showInnerColorOptions = false;
    this.parent.applyDesignOnJacket();
    
    // if(this.parent.config.customisationDefaults.inner[0].innerDesign){
    //   this.parent.removeAllOutLines();
    //   this.parent.removeActivePath(this.parent.selectedArea.selector);
    //   this.parent.selectedArea = '';
    // }
  }

  setArtworkStyle(color){
    if(!this.parent.selectedArea.selectedStyle.image.artworkColor){
      this.parent.selectedArea.selectedStyle.image.artworkColor = {};
    }
    this.parent.selectedArea.selectedStyle.image.artworkColor[this.artworkColorOptionsSelection] = color;
    // this.parent.applyDesignOnJacket()
    this.parent.setImageSrc(this.parent.selectedArea, '', true);
  }

  parseInt(val){
    return parseInt(val);
  }

  mouseEnter(className){
    console.log('mouseEnter className : ', className)
    document.getElementsByClassName(className)[0].classList.add('move_btn_over');
  }
  mouseLeave(className){
    document.getElementsByClassName(className)[0].classList.remove('move_btn_over');
  }

  moveTop(){
    console.log("moveTop");
    this.parent.selectedArea.selectedStyle.image['y'] = parseInt(this.parent.selectedArea.selectedStyle.image['y'])-1;
    this.parent.setImageSrc(this.parent.selectedArea, '', true);
  }

  moveBottom(){
    console.log("moveBottom");
    this.parent.selectedArea.selectedStyle.image['y'] = parseInt(this.parent.selectedArea.selectedStyle.image['y'])+1;
    this.parent.setImageSrc(this.parent.selectedArea, '', true);
  }

  moveLeft(){
    console.log("moveLeft");
    this.parent.selectedArea.selectedStyle.image['x'] = parseInt(this.parent.selectedArea.selectedStyle.image['x'])-1;
    this.parent.setImageSrc(this.parent.selectedArea, '', true);
  }

  moveRight(){
    console.log("moveRight");
    this.parent.selectedArea.selectedStyle.image['x'] = parseInt(this.parent.selectedArea.selectedStyle.image['x'])+1;
    this.parent.setImageSrc(this.parent.selectedArea, '', true);
  }

  zoomIn(){
    (this.parent.selectedArea.selectedStyle.image['zoom'] < 10) 
      && 
    (this.parent.selectedArea.selectedStyle.image['zoom'] = parseFloat(<any>parseFloat(this.parent.selectedArea.selectedStyle.image['zoom']) + 0.1));
    
    console.log("this.parent.selectedArea.selectedStyle.image['zoom']  : ", this.parent.selectedArea.selectedStyle.image['zoom'])
    
    this.parent.setImageSrc(this.parent.selectedArea, '', true);
  }

  zoomOut(){
    (this.parent.selectedArea.selectedStyle.image['zoom'] >= .1) 
      && 
    (this.parent.selectedArea.selectedStyle.image['zoom'] = <any>parseFloat(this.parent.selectedArea.selectedStyle.image['zoom']).toFixed(2) - (0.1));
    this.parent.setImageSrc(this.parent.selectedArea, '', true);
  }
  

}



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/design-options/design-options.component.ts